"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3CoreMethod = _interopRequireDefault(require("web3-core-method"));

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _web3CoreHelpers = require("web3-core-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Web3Calls = function Web3Calls(requestManager) {
  var _this = this;

  _classCallCheck(this, Web3Calls);

  var ethereumCalls = [new _web3CoreMethod.default({
    name: 'getId',
    call: 'net_version',
    params: 0,
    outputFormatter: _web3Utils.default.hexToNumber
  }), new _web3CoreMethod.default({
    name: 'getGasPrice',
    call: 'eth_gasPrice',
    params: 0
  }), new _web3CoreMethod.default({
    name: 'getBlockNumber',
    call: 'eth_blockNumber',
    params: 0
  }), new _web3CoreMethod.default({
    name: 'getBlockByNumber',
    call: 'eth_getBlockByNumber',
    params: 2
  }), new _web3CoreMethod.default({
    name: 'estimateGas',
    call: 'eth_estimateGas',
    params: 1,
    inputFormatter: [_web3CoreHelpers.formatters.inputCallFormatter],
    outputFormatter: _web3Utils.default.hexToNumber
  }), new _web3CoreMethod.default({
    name: 'signTransaction',
    call: 'eth_signTransaction',
    params: 1,
    inputFormatter: [_web3CoreHelpers.formatters.inputTransactionFormatter]
  }), new _web3CoreMethod.default({
    name: 'sendSignedTransaction',
    call: 'eth_sendRawTransaction',
    params: 1,
    inputFormatter: [null]
  }), new _web3CoreMethod.default({
    name: 'getTransactionReceipt',
    call: 'eth_getTransactionReceipt',
    params: 1,
    inputFormatter: [null]
  }), new _web3CoreMethod.default({
    name: 'getTransactionCount',
    call: 'eth_getTransactionCount',
    params: 2,
    inputFormatter: [function (address) {
      if (_web3Utils.default.isAddress(address.toLowerCase())) {
        return address;
      }

      throw new Error('Address ' + address + ' is not a valid address to get the "transactionCount".');
    }, function () {
      return 'latest';
    }]
  })];
  this.ethereumCalls = {};
  ethereumCalls.forEach(function (call) {
    call.attachToObject(_this.ethereumCalls);
    call.setRequestManager(requestManager);
  });
  return this.ethereumCalls;
};

var _default = Web3Calls;
exports.default = _default;